
import { entry as uploader } from './uploader.vue';
import { entry as companyfullname } from './companyfullName.vue'
import { entry as reportdata } from './reportDate.vue'
import { entry as industry } from './industry.vue'
import { entry as companyseccode } from './companyseccode.vue'
import { entry as attachment } from "./attachment.vue"
import { entry as textList } from "./textList.vue"

const renders=[
    uploader, companyfullname, reportdata, industry, companyseccode, attachment, textList
]

export default renders